import PageLayout from "layouts/PageLayout";
import TableData from "./tableData";

function Orders() {
  return (
    <PageLayout
      title={'Users'}
    >
      <TableData />
    </PageLayout>
  );
}

export default Orders;
